import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AnimatePresence, motion } from "framer-motion";
import useLenis from "@/lib/useLenis";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import ClosureNotice from "@/components/ClosureNotice";

import HomePage from "@/pages/HomePage";
import TraditionPage from "@/pages/TraditionPage";
import ServicePage from "@/pages/ServicePage";
import VespaPage from "@/pages/VespaPage";
import PonyPage from "@/pages/PonyPage";
import ZubehoerPage from "@/pages/ZubehoerPage";
import CasaPage from "@/pages/CasaPage";

function Layout() {
  useLenis();
  const location = useLocation();
  return (
    <div className="min-h-screen flex flex-col bg-[var(--cream)]">
      <ClosureNotice />
      <Header />
      <ScrollToTop />
      <AnimatePresence mode="wait">
        <motion.main
          key={location.pathname}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
          className="flex-1"
        >
          <Outlet />
        </motion.main>
      </AnimatePresence>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#2C2F33",
            color: "#F9F8F6",
            border: "1px solid #4A4D52",
            borderRadius: 0,
            fontFamily: "Outfit, sans-serif",
            fontSize: "13px",
            letterSpacing: "0.04em",
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/tradition" element={<TraditionPage />} />
            <Route path="/service" element={<ServicePage />} />
            <Route path="/vespa-piaggio" element={<VespaPage />} />
            <Route path="/pony-mofa" element={<PonyPage />} />
            <Route path="/zubehoer" element={<ZubehoerPage />} />
            <Route path="/casa-markus" element={<CasaPage />} />
            <Route path="*" element={<HomePage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
